module.exports = __webpack_public_path__ + "img/factura.5b60b66e.svg";